// LOCAL POS / OFFLINE PILOT indicator — shows ONLY when the app is served by
// a local_pos backend on loopback. Cloud production: zero requests, zero UI.
import React, { useEffect, useState } from 'react';

const isLoopback = typeof window !== 'undefined' &&
  ['localhost', '127.0.0.1'].includes(window.location.hostname);

export const LocalPosBadge = () => {
  const [info, setInfo] = useState(null);

  useEffect(() => {
    if (!isLoopback) return;
    fetch('/api/pos/mode')
      .then((r) => (r.ok ? r.json() : null))
      .then((d) => { if (d && d.local_pos) setInfo(d); })
      .catch(() => {});
  }, []);

  if (!info) return null;
  return (
    <div
      data-testid="local-pos-indicator"
      className="fixed top-0 left-1/2 -translate-x-1/2 z-[9999] px-3 py-0.5 rounded-b-md text-[11px] font-bold tracking-widest select-none pointer-events-none"
      style={{ background: '#b45309', color: '#fff7ed', boxShadow: '0 2px 8px rgba(0,0,0,0.35)' }}
      title={`Локал горим — DB: ${info.db_name || ''} (cloud sync идэвхгүй)`}
    >
      LOCAL POS — OFFLINE PILOT
    </div>
  );
};
